/**
 * The save a canvas editor still has in flight after it closes. The route
 * loader waits for it, so leaving a canvas and coming straight back shows the
 * saved document rather than the one from before the last edit.
 */
const pending = new Map<string, Promise<unknown>>()

export function trackPendingSave(canvasId: string, save: Promise<unknown>) {
  pending.set(canvasId, save)
  void save.finally(() => {
    if (pending.get(canvasId) === save) {
      pending.delete(canvasId)
    }
  })
}

export function awaitPendingSave(canvasId: string): Promise<unknown> {
  return pending.get(canvasId) ?? Promise.resolve()
}
